import 'bootstrap';

window.addEventListener('DOMContentLoaded', (event) => {
  // Hamburger Menu
  const burger = document.getElementById("hamburgler");
  burger.addEventListener("click", () => {
    burger.classList.toggle("is-active");
  });
});